















































import { Component, Vue } from "vue-property-decorator";
import { checkStyleUsage, deleteStyle } from "@/services/styles/stylesService";

    @Component
export default class StyleDeleteModal extends Vue {
        // local state
        styleToBeDeleted = "";
        name = "";
        isSaved: boolean = false;
        // lifecycle hooks

        // computed

        // methods
        handleEnter(e: KeyboardEvent) {
            if (e.key === "Enter") {
                if (this.styleToBeDeleted !== "") this.confirmDelete();
                else this.confirmStyleInUse();
            }
        }

        removeEvent() {
            window.removeEventListener("keydown", this.handleEnter);
            this.isSaved = false;
            this.styleToBeDeleted = "";
        }

        open(styleId: string, name: string) {
            let styleInUse = false;
            this.name = name;
            checkStyleUsage(styleId).then(response => {
                window.addEventListener("keydown", this.handleEnter);
                styleInUse = response;
                if (styleInUse) {
                    this.$bvModal.show("modal-styleInUse");
                    return;
                }
                this.styleToBeDeleted = styleId;
                this.$bvModal.show("modal-deleteStyle");
            });
        }

        declineDelete() {
            this.$bvModal.hide("modal-deleteStyle");
            this.styleToBeDeleted = "";
        }

        confirmDelete() {
            if (this.isSaved) return;
            this.isSaved = true;
            deleteStyle(this.styleToBeDeleted).then(() => {
                this.$emit("reload");
                this.styleToBeDeleted = "";
                this.$bvModal.hide("modal-deleteStyle");
            });
        }

        confirmStyleInUse() {
            this.$bvModal.hide("modal-styleInUse");
        }
}
